import './lle_terms_condition.css';
import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { ADD_LLE, authKey } from '../../../../common/URLs';

import { loaderService } from '../../../../common/custom-loader/loader-service';
import { Container, Card, CardContent, Dialog, DialogContent, DialogActions, Button, ToggleButton, ToggleButtonGroup, FormGroup, FormControlLabel, Checkbox, Stack, Box, Typography, Grid, FormHelperText, FormControl } from '@mui/material';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { PROD } from '../../../../common/constants';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { ConfirmationPopover } from '../../../../common/commonPopovers/confirmationPopover';
import { PreRegPopover } from '../../../../common/commonPopovers/preRegPopver';
import { ArrowBackIosNewIcon, SubmitIcon } from '../../../../common/icons';
import apiClient from '../../../../axios';

const LLETermsCondition = () => {
    const { t } = useTranslation();
    const [prevScreenData, setPrevScreenData] = useState();
    const [isAgreedToEnvionmentHealthSafetyLawsRegulation, setIsAgreedToEnvionmentHealthSafetyLawsRegulation] = useState(false);
    const [isAgreedToResourceSustanability, setIsAgreedToResourceSustanability] = useState(false);
    const [isSelfCertified, setIsSelfCertified] = useState(false);
    const [selectedApplicant, setSelectedApplicant] = useState('Individual');
    const [lleDetails, setLleDetails] = useState();
    const [lleError, setLleError] = useState('');
    const decoded = getLocalStorageItem('id_token') ? (getLocalStorageItem('id_token') == "PreReg") ? null : jwt(getLocalStorageItem('id_token')) : null;
    const [errorMessage, setErrorMessage] = useState({
        pageError: ''
    });
    const navigate = useNavigate();
    const location = useLocation();
    const [logModalOpenConfirm, setLogModalOpenConfirm] = useState(false);
    const handleLogModalConfirmOpen = () => setLogModalOpenConfirm(true);
    const handleLogModalConfirmClose = () => setLogModalOpenConfirm(false);
    const [logModalOpenSuccess, setLogModalOpenSuccess] = useState(false);
    const handleLogModalSuccessOpen = () => setLogModalOpenSuccess(true);
    const handleLogModalSuccessClose = () => setLogModalOpenSuccess(false);

    useEffect(() => {
        setPrevScreenData(location.state.data)
        setSelectedApplicant(location.state.data.applicantType);

    }, [prevScreenData]);

    useEffect(() => {
        if (lleDetails) {
            if (lleDetails.isSuccess) {
                handleLogModalSuccessOpen();
            }
            else {
                if (lleDetails.message) {
                    toast.error(lleDetails.message);
                } else
                    toast.error("LLE creation failed");
            }
        }
    }, [lleDetails]);
    const onSubmit = () => {
        if (!(isSelfCertified && isAgreedToResourceSustanability && isAgreedToEnvionmentHealthSafetyLawsRegulation)) {
            setErrorMessage({ ...errorMessage, pageError: "*Please check all the check boxes" });
        }
        else {
            setErrorMessage({ ...errorMessage, pageError: "" });
            handleLogModalConfirmOpen();
        }
    }

    const onApplicantClick = (e, applicantSelected) => {
        e.preventDefault()
        if (applicantSelected === 'Individual') {
            setSelectedApplicant('Individual')
        } else if (applicantSelected === 'SHG/Co-opetative') {
            setSelectedApplicant('SHG/Co-opetative')
        } else if (applicantSelected === 'Firm/Enterprise') {
            setSelectedApplicant('Firm/Enterprise')
        }
    }
    const isAgreedToEnvionmentHealthSafetyLawsOnChange = (e) => {
        if (isAgreedToEnvionmentHealthSafetyLawsRegulation === false) {
            setIsAgreedToEnvionmentHealthSafetyLawsRegulation(true);
            setErrorMessage({ ...errorMessage, pageError: "" });
        }
        else {
            setIsAgreedToEnvionmentHealthSafetyLawsRegulation(false)
        }
    }
    const isAgreedToResourceSustanabilityOnChange = (e) => {
        if (isAgreedToResourceSustanability === false) {
            setIsAgreedToResourceSustanability(true)
            setErrorMessage({ ...errorMessage, pageError: "" });
        }
        else {
            setIsAgreedToResourceSustanability(false)
        }
    }
    const isSelfCertifiedOnChange = (e) => {
        if (isSelfCertified === false) {
            setIsSelfCertified(true)
            setErrorMessage({ ...errorMessage, pageError: "" });
        }
        else {
            setIsSelfCertified(false)
        }
    }
    const confirmSubmission = () => {
        handleLogModalConfirmClose();
        let headers = {
            AuthKey: authKey,
        }
        if (getLocalStorageItem('id_token') && getLocalStorageItem('id_token') !== "PreReg") {
            headers = {
                AuthKey: authKey,
                Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
            }
        }
        const dataForApi = {
            ...prevScreenData,
            "isAgreedToEnvionmentHealthSafetyLawsRegulation": isAgreedToEnvionmentHealthSafetyLawsRegulation,
            "isAgreedToResourceSustanability": isAgreedToResourceSustanability,
            "isSelfCertified": isSelfCertified
        }
        loaderService.showLoader()
        apiClient
            .post(ADD_LLE,
                dataForApi,
                {
                    headers: headers
                }
            )
            .then((response) => {
                setLleDetails(response.data);
                loaderService.hideLoader()

            })
            .catch(function (error) {
                setLleError(error);
                loaderService.hideLoader()

            });
    }



    return (
        <>
            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG11</p>}
                <Card>
                    <CardContent>
                        <Typography variant="subtitle2" gutterBottom>
                            {t('preReg.applicantType')}
                        </Typography>
                        <ToggleButtonGroup style={{ display: "flex", overflow: "auto" }}
                            color="primary"
                            value={selectedApplicant}
                            exclusive
                            onChange={(e) => onApplicantClick(e)}
                            aria-label="Platform"
                        >
                            <ToggleButton disabled value="Individual">{t('preReg.individual')}</ToggleButton>
                            <ToggleButton disabled value="SHG/Co-opetative">{t('preReg.shg')}/{t('preReg.cooperative')}</ToggleButton>
                            <ToggleButton disabled value="Firm/Enterprise">{t('preReg.firm')}/{t('preReg.enterprise')}</ToggleButton>
                        </ToggleButtonGroup>
                        <Typography variant="h6" gutterBottom style={{ marginTop: "1em" }}>
                            {t('preReg.generalTerms&Conditions')}
                        </Typography>
                        <Typography variant="subtitle2" gutterBottom style={{ marginTop: "1em" }}>
                            {t('preReg.termHeading')}:
                        </Typography>
                        <FormControl sx={{ m: 3 }} required variant="standard">
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={isAgreedToEnvionmentHealthSafetyLawsRegulation} onChange={(e) => isAgreedToEnvionmentHealthSafetyLawsOnChange(e)} name="FirstTermChecox" />
                                    }
                                    label={t('preReg.term1')}
                                />
                                <Typography variant="subtitle2" gutterBottom style={{ marginTop: "1em" }}>
                                    {t('preReg.termSubheading')}:
                                </Typography>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={isAgreedToResourceSustanability} onChange={(e) => isAgreedToResourceSustanabilityOnChange(e)} name="SecondTermChecox" />
                                    }
                                    label={t('preReg.term2')}
                                />
                            </FormGroup>
                        </FormControl>
                        <Typography variant="h6" gutterBottom style={{ marginTop: "1em" }}>
                            {t('preReg.undertaking')}
                        </Typography>
                        <Typography variant="subtitle2" gutterBottom style={{ marginTop: "1em" }}>
                            {t('preReg.termSubheading2')}                        </Typography>
                        <FormControl sx={{ m: 3 }} required
                            error={errorMessage.pageError} variant="standard">
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox checked={isSelfCertified} onChange={(e) => isSelfCertifiedOnChange(e)} name="ThirdTermChecox" />
                                    }
                                    label={t('preReg.term3')}
                                />

                            </FormGroup>
                            <FormHelperText>{errorMessage.pageError}</FormHelperText>
                        </FormControl>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button sx={{ minWidth: 100 }} variant="contained" startIcon={<ArrowBackIosNewIcon />} onClick={() => (navigate(getLocalStorageItem('id_token') ? '/registrationHome/preregistration/llemandatorypage' : '/preregistration/llemandatorypage', { state: { data: prevScreenData } }))}>{t('preReg.previous')}</Button>
                    <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" endIcon={<SubmitIcon />} onClick={onSubmit}>{t('preReg.submit')}</Button>
                </Box>
            </Container >
            <ConfirmationPopover action="Submit" onOpen={logModalOpenConfirm} onConfirm={confirmSubmission} onClose={handleLogModalConfirmClose} />
            <PreRegPopover onOpen={logModalOpenSuccess} onClose={handleLogModalSuccessClose} urn={lleDetails?.lle?.regStakeholderMaster?.urn} message="LLE created successfully" navigate={navigate} navigatePath={decoded != null && decoded && decoded.emails && decoded.emails[0] ? '/registrationHome/dashboard' : '/'} />
        </>
    );
}
export default LLETermsCondition;
